import { api } from "api/apiService";

// Список стандартних параметрів API, які НЕ є динамічними фільтрами властивостей
const STANDARD_PARAMS = ["page", "page_size", "subject_identifier", "subject_types"];

/**
 * Завантажує історію активності (логи) з урахуванням параметрів фільтрації.
 * @param {object} [filters={}] - Об'єкт з параметрами для фільтрації.
 * @returns {Promise<object>} Проміс, що повертає об'єкт з даними логів.
 */
export const fetchActivityLog = (filters) => {
  // Копіюємо лише ті фільтри, які мають реальне значення
  const cleanFilters = {};
  const dynamicFilters = {}; // Об'єкт для динамічних фільтрів (properties)

  for (const key in filters) {
    const value = filters[key];

    // Пропускаємо пусті значення
    if (value === null || value === undefined || value === "") {
      continue;
    }

    // Обробка для 'subject_types', має бути непорожнім масивом
    if (key === "subject_types") {
      if (Array.isArray(value) && value.length > 0) {
        cleanFilters[key] = value;
      }
    }
    // Загальна логіка для інших стандартних полів
    else if (STANDARD_PARAMS.includes(key)) {
      cleanFilters[key] = value;
    }
    // Все інше вважаємо динамічними фільтрами для поля properties
    else {
      dynamicFilters[key] = value;
    }
  }

  // Якщо є динамічні фільтри, додаємо їх об'єктом
  if (Object.keys(dynamicFilters).length > 0) {
    for (const key in dynamicFilters) {
      cleanFilters[`filters[${key}]`] = dynamicFilters[key];
    }
  }

  return api.get("/activity-log", cleanFilters);
};
